import React from 'react';
import '../styles/ReleaseNotesModal.css';

// A change may end with a help link — [Help: Page](https://…) — see the release-management
// skill. Only http(s) URLs become links; anything else stays as plain text.
// A trailing "Help:" link is drawn as a small pill on its own line, right-aligned.
function renderMd(text) {
  const html = text
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\[(?:Help:\s*)([^\]]+)\]\((https?:\/\/[^)\s"]+)\)/g,
      '<a class="rn-help-link" href="$2" target="_blank" rel="noopener noreferrer">'
      + '<span class="rn-help-icon">?</span>$1<span class="rn-help-arrow">↗</span></a>')
    .replace(/\[([^\]]+)\]\((https?:\/\/[^)\s"]+)\)/g,
      '<a class="rn-link" href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  return <span dangerouslySetInnerHTML={{ __html: html }} />;
}

function ReleaseNotesModal({ releases, onClose }) {
  if (!releases || releases.length === 0) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Release Notes</h2>
          <button className="modal-close" onClick={onClose} title="Close">×</button>
        </div>

        <div className="modal-body">
          {releases.map((release, idx) => (
            <div key={idx} className="release-section">
              <div className="release-header">
                <span className="release-version">v{release.version}</span>
                <span className={`release-status ${release.status}`}>
                  {release.status}
                </span>
                <span className="release-date">{release.date}</span>
              </div>

              {release.features && release.features.length > 0 && (
                <div className="release-part">
                  <h4>Features</h4>
                  <ul>
                    {release.features.map((feature, idx) => (
                      <li key={idx}>{renderMd(feature)}</li>
                    ))}
                  </ul>
                </div>
              )}

              {release.fixes && release.fixes.length > 0 && (
                <div className="release-part">
                  <h4>Fixes</h4>
                  <ul>
                    {release.fixes.map((fix, idx) => (
                      <li key={idx}>{renderMd(fix)}</li>
                    ))}
                  </ul>
                </div>
              )}

              {release.changes && release.changes.length > 0 && (
                <div className="release-part">
                  <h4>Changes</h4>
                  <ul>
                    {release.changes.map((change, idx) => (
                      <li key={idx}>{renderMd(change)}</li>
                    ))}
                  </ul>
                </div>
              )}

              {idx < releases.length - 1 && <div className="release-divider"></div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ReleaseNotesModal;
